import * as React from 'react';
import { ContextModalProps } from '@mantine/modals';
import { Text, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const HelpModal = ({ context, id, innerProps }: ContextModalProps<{ modalBody: string }>) => {
    const { t } = useTranslation('common');

    return (
        <>
            <Text size="sm">{innerProps.modalBody}</Text>
            <Button fullWidth mt="md" onClick={() => context.closeModal(id)}>
                <Text transform="capitalize">{t('close')}</Text>
            </Button>
        </>
    );
};
